import React, { useState, useEffect } from 'react';
import { Combobox } from 'evergreen-ui';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { api } from '../../services/api';
import appTypes from '../../constants/types';

const SelectTeamInput = ({ defaultValue, onChange, disabled }) => {
  const [loading, setLoading] = useState(true);
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await api.teams.list(1, 1000); // TODO: Make dynamic
        setTeams(_.sortBy(data.data, 'label'));
        setLoading(false);
        return;
      } catch (error) {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <Combobox
      items={teams}
      initialSelectedItem={defaultValue}
      onChange={(selected) => onChange && onChange(selected || null)}
      itemToString={(item) => (item ? item.name : '')}
      disabled={disabled}
      isLoading={loading}
      width="75%"
      openOnFocus
      data-testid="team" />
  );
};

SelectTeamInput.propTypes = {
  defaultValue: appTypes.team.props,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

SelectTeamInput.defaultProps = {
  defaultValue: null,
};

export default SelectTeamInput;
